import { queries } from 'RestAPIs/rapini';

export const useClaMaintenance = () => {
  const { data: clas, isLoading, isError, refetch } = queries.useGetClas();

  return {
    clas,
    isLoading,
    isError,
    refetch
  };
};
